// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { useWebhooksRequestConfig } from 'hooks/useWebhooksBaseUrl'
import {
  updateNotificationDestination,
  UpdateNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useUpdateNotificationDestinationMutation = () => {
  const requestConfig = useWebhooksRequestConfig()
  return useMutation({
    mutationFn: (data: Omit<UpdateNotificationDestinationRequest, keyof typeof requestConfig>) =>
      updateNotificationDestination({ ...data, ...requestConfig }),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useUpdateNotificationDestinationMutation', error, data)
    },
  })
}
